import { PromoDetailPage } from '@/features/promo/pages/PromoDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/promo/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["promo.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PromoDetailPage,
})
